/**
 * The meeting held for as long as a page is open: made once, told to take the
 * camera at the door, and left behind when the page goes.
 */
import { useCallback, useEffect, useRef, useState, useSyncExternalStore } from "react";
import type { LiveJoinResponse } from "../../../shared/types";
import { Meeting, type MeetingState } from "./meeting";

export function useMeeting(host: boolean, join: () => Promise<LiveJoinResponse>): {
  meeting: Meeting;
  state: MeetingState;
} {
  // Why a ref: the page makes a new `join` on every draw, and the meeting must not.
  const latest = useRef(join);
  latest.current = join;
  const [meeting] = useState(() => new Meeting({ host, join: () => latest.current() }));
  useEffect(() => {
    void meeting.openDoor();
    return () => void meeting.dispose();
  }, [meeting]);
  const subscribe = useCallback((changed: () => void) => meeting.subscribe(changed), [meeting]);
  const state = useSyncExternalStore(subscribe, meeting.snapshot);
  return { meeting, state };
}
